import { render } from "./MyDomains.vue?vue&type=template&id=2ff7da80&scoped=true"
import script from "./MyDomains.vue?vue&type=script&lang=ts"
export * from "./MyDomains.vue?vue&type=script&lang=ts"

import "./MyDomains.vue?vue&type=style&index=0&id=2ff7da80&scoped=true&lang=scss"
import "./MyDomains.vue?vue&type=style&index=1&id=2ff7da80&lang=scss"
script.render = render
script.__scopeId = "data-v-2ff7da80"

export default script